import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Logoutsession_one_Device } from '../Redux/Actions/Devices_Action';

import {
  Box, Drawer, List, ListItem, ListItemIcon, ListItemText,
  Collapse, Typography, Tooltip,
} from '@mui/material';

import GridViewRoundedIcon           from '@mui/icons-material/GridViewRounded';
import PeopleAltOutlinedIcon         from '@mui/icons-material/PeopleAltOutlined';
import Inventory2OutlinedIcon        from '@mui/icons-material/Inventory2Outlined';
import PersonOutlinedIcon            from '@mui/icons-material/PersonOutlined';
import BarChartOutlinedIcon          from '@mui/icons-material/BarChartOutlined';
import CampaignOutlinedIcon          from '@mui/icons-material/CampaignOutlined';
import GroupsOutlinedIcon            from '@mui/icons-material/GroupsOutlined';
import SettingsOutlinedIcon          from '@mui/icons-material/SettingsOutlined';
import ShieldOutlinedIcon            from '@mui/icons-material/ShieldOutlined';
import HelpOutlineIcon               from '@mui/icons-material/HelpOutline';
import AddCircleOutlinedIcon         from '@mui/icons-material/AddCircleOutlined';
import AccountCircleOutlinedIcon     from '@mui/icons-material/AccountCircleOutlined';
import LogoutIcon                    from '@mui/icons-material/Logout';
import ChevronLeftIcon               from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon              from '@mui/icons-material/ChevronRight';
import { ExpandLess, ExpandMore }    from '@mui/icons-material';
import AccountTreeOutlinedIcon       from '@mui/icons-material/AccountTreeOutlined';
import ApartmentOutlinedIcon         from '@mui/icons-material/ApartmentOutlined';
import HomeWorkOutlinedIcon          from '@mui/icons-material/HomeWorkOutlined';
import LocationSearchingOutlinedIcon from '@mui/icons-material/LocationSearchingOutlined';
import AddLocationOutlinedIcon       from '@mui/icons-material/AddLocationOutlined';
import PersonAddAltOutlinedIcon      from '@mui/icons-material/PersonAddAltOutlined';
import PersonSearchOutlinedIcon      from '@mui/icons-material/PersonSearchOutlined';
import VideoSettingsOutlinedIcon     from '@mui/icons-material/VideoSettingsOutlined';
import WebhookIcon                   from '@mui/icons-material/Webhook';
import FacebookIcon                  from '@mui/icons-material/Facebook';
import ExpandCircleDownOutlinedIcon  from '@mui/icons-material/ExpandCircleDownOutlined';
import ScreenRotationOutlinedIcon    from '@mui/icons-material/ScreenRotationOutlined';
import TrendingUpIcon                from '@mui/icons-material/TrendingUp';
import ChecklistIcon                 from '@mui/icons-material/Checklist';
import AssessmentIcon                from '@mui/icons-material/Assessment';
import Language                      from '@mui/icons-material/Language';
import HorizontalSplitOutlinedIcon   from '@mui/icons-material/HorizontalSplitOutlined';
import BubbleChartOutlinedIcon       from '@mui/icons-material/BubbleChartOutlined';
import DoNotDisturbAltOutlinedIcon   from '@mui/icons-material/DoNotDisturbAltOutlined';
import DeleteOutlineIcon             from '@mui/icons-material/DeleteOutline';
import PersonPinOutlinedIcon         from '@mui/icons-material/PersonPinOutlined';
import SwitchAccountOutlinedIcon     from '@mui/icons-material/SwitchAccountOutlined';
import StackedLineChartOutlinedIcon  from '@mui/icons-material/StackedLineChartOutlined';
import Diversity3Icon                from '@mui/icons-material/Diversity3';
import ShowChartIcon                 from '@mui/icons-material/ShowChart';
import AccountBoxIcon                from '@mui/icons-material/AccountBox';
import AddTaskIcon                   from '@mui/icons-material/AddTask';
import AssignmentIcon                from '@mui/icons-material/Assignment';
import AssistantPhotoIcon            from '@mui/icons-material/AssistantPhoto';
import LoupeIcon                     from '@mui/icons-material/Loupe';
import WhereToVoteIcon               from '@mui/icons-material/WhereToVote';
import SouthAmericaIcon              from '@mui/icons-material/SouthAmerica';
import ArrowBackOutlinedIcon         from '@mui/icons-material/ArrowBackOutlined';
import StorageOutlinedIcon           from '@mui/icons-material/StorageOutlined';

// ─── tokens ───────────────────────────────────────────────────────────────────
const C = {
  sidebarBg: '#F7F8FC',
  topBg:     '#F7F8FC !important',
  border:    '#E8EAF0',
  accent:    '#1A3ECF !important',
  text:      '#1C2340',
  textMuted: '#7B829A !important',
  hoverBg:   'rgba(26,62,207,0.04)',
  ctaBg:     '#1A3ECF',
  ctaHover:  '#1330A6 ',
  divider:   '#E8EAF0',
};

const EXPANDED_WIDTH  = 242;
const COLLAPSED_WIDTH = 64;

// ─── Data Center routes per role ──────────────────────────────────────────────
const DATA_CENTER_ROUTES = {
  Admin:         { dashboard: '/AllLeadsForAdminCRMDataQuickNumbers', leads: '/AllLeadsForAdminCRMDatapage',    returnTo: '/AllLeadsForAdmin' },
  'Team Leader': { dashboard: '/TeamLeaderQuickNumbersCRMData',       leads: '/TeamLeaderCRMDATAALLLeads',      returnTo: '/AllLeadsForTeamLeader' },
  Sales:         { dashboard: '/SalesQuickNumberCRMData',             leads: '/SalesAllLeadsCRMDATA',           returnTo: '/AllLeadsForSales' },
  Marketer:      { dashboard: '/QuickNumbersForMarketerCRMDATA',      leads: '/ALLLeadsForMarketerCRMDATA',     returnTo: '/ALLLeadsForMarketer' },
  Manager:       { dashboard: '/dashboradmanagerCrmData',             leads: '/AllLeadsManagercrmdata',         returnTo: '/LeadsForManagers' },
};

// ─── All Data Center paths (for detection) ────────────────────────────────────
const ALL_DATA_CENTER_PATHS = [
  '/AllLeadsForAdminCRMDataQuickNumbers', '/AllLeadsForAdminCRMDatapage',
  '/TeamLeaderQuickNumbersCRMData',       '/TeamLeaderCRMDATAALLLeads',
  '/SalesQuickNumberCRMData',             '/SalesAllLeadsCRMDATA',
  '/QuickNumbersForMarketerCRMDATA',      '/ALLLeadsForMarketerCRMDATA',
  '/dashboradmanagerCrmData',             '/AllLeadsManagercrmdata',
];

// ─── menus ────────────────────────────────────────────────────────────────────
const adminMenuItems = [
  { text: 'Dashboard', icon: <GridViewRoundedIcon />,   path: '/dashboard' },
  { text: 'Leads',     icon: <PeopleAltOutlinedIcon />, path: '/AllLeadsForAdmin' },
  { text: 'Inventory', icon: <Inventory2OutlinedIcon />, children: [
      { text: 'Projects',   path: '/Project',         icon: <AccountTreeOutlinedIcon /> },
      { text: 'City',       path: '/AllCitiesShow',   icon: <ApartmentOutlinedIcon /> },
      { text: 'Developers', path: '/Developers',      icon: <HomeWorkOutlinedIcon /> },
      { text: 'Region',     path: '/Regionsandareas', icon: <LocationSearchingOutlinedIcon /> },
      { text: 'Areas',      path: '/Areas',           icon: <AddLocationOutlinedIcon /> },
  ]},
  { text: 'Sales', icon: <PersonOutlinedIcon />, children: [
      { text: 'Add Sales',    path: '/Addsales', icon: <PersonAddAltOutlinedIcon /> },
      { text: 'Manage Sales', path: '/sales',    icon: <PersonSearchOutlinedIcon /> },
  ]},
  { text: 'Marketing', icon: <CampaignOutlinedIcon />, children: [
    { text: 'Campaigns',   icon: <CampaignOutlinedIcon />,      path: '/Campaigns' },
    { text: 'Campaign Report', icon: <BarChartOutlinedIcon />, path: '/MarketingReports' },
   { text: 'Sales & Campaigns Report',   icon: <CampaignOutlinedIcon />,      path: '/LeadsWithsalesincampaign' },

      
      { text: 'Channel',     icon: <VideoSettingsOutlinedIcon />,  path: '/Channel' },
      { text: 'Integration', icon: <WebhookIcon />, children: [
          { text: 'Webhook',          path: '/integration',         icon: <WebhookIcon /> },
          { text: 'Facebook',         path: '/Facebookintegration', icon: <FacebookIcon /> },
          { text: 'PF Configration', path: '/pf-configuration',     icon: <WebhookIcon /> },
          { text: 'PF Integration', path: '/property-finder-integration',     icon: <WebhookIcon /> },

          
          { text: 'More Integration', path: '/MoreIntegration',     icon: <WebhookIcon /> },

      ]},
  ]},
  { text: 'Users', icon: <GroupsOutlinedIcon />, children: [
      { text: 'Users',        path: '/Users',          icon: <PeopleAltOutlinedIcon /> },
      { text: 'Rotation',     path: '/MoreRotation',   icon: <ScreenRotationOutlinedIcon /> },
      { text: 'User Devices', path: '/AllUserDevices', icon: <ScreenRotationOutlinedIcon /> },
  ]},
  { text: 'Settings', icon: <SettingsOutlinedIcon />, children: [
      { text: 'Reports', icon: <AssessmentIcon />, children: [
          { text: 'Sales Report',     path: '/SalesReportCountLeadsInMonths', icon: <TrendingUpIcon /> },
          { text: 'Done Deal Report', path: '/DoneDealReport',                icon: <ChecklistIcon /> },
      ]},
      { text: 'Company Profile',   path: '/CompanyProfile',   icon: <SettingsOutlinedIcon /> },
      { text: 'Company Domains',   path: '/CompanyDomains',   icon: <Language /> },
      { text: 'Stages',            path: '/Stages',           icon: <HorizontalSplitOutlinedIcon /> },
      { text: 'Communication Way', path: '/Communicationway', icon: <BubbleChartOutlinedIcon /> },
      { text: 'Cancel Reason',     path: '/cancelreasons',    icon: <DoNotDisturbAltOutlinedIcon /> },
      { text: 'Trash', icon: <DeleteOutlineIcon />, children: [
          { text: 'Leads Trash',          path: '/AllLeadsnotactivated', icon: <DeleteOutlineIcon /> },
          { text: 'Stages Type Trash',    path: '/AllStagesTypeTrash',   icon: <DeleteOutlineIcon /> },
          { text: 'Stages Trash',         path: '/AllStagesTrash',       icon: <DeleteOutlineIcon /> },
          { text: 'Sales Trash',          path: '/AllSalesTrash',        icon: <DeleteOutlineIcon /> },
          { text: 'Users Trash',          path: '/AllUsersTrash',        icon: <DeleteOutlineIcon /> },
          { text: 'Comm Way Trash',       path: '/AllCommWayTrash',      icon: <DeleteOutlineIcon /> },
          { text: 'Campaign Trash',       path: '/AllCampaignTrash',     icon: <DeleteOutlineIcon /> },
          { text: 'Developers Trash',     path: '/AllDevelopersTrash',   icon: <DeleteOutlineIcon /> },
          { text: 'Projects Trash',       path: '/AllProjectsTrash',     icon: <DeleteOutlineIcon /> },
          { text: 'Cancel Reasons Trash', path: '/CancelResanosTrash',   icon: <DeleteOutlineIcon /> },
          { text: 'Channels Trash',       path: '/ChanalsTrash',         icon: <DeleteOutlineIcon /> },
          { text: 'Regions Trash',        path: '/RegionsTrash',         icon: <DeleteOutlineIcon /> },
          { text: 'Area Trash',           path: '/AreaTrash',            icon: <DeleteOutlineIcon /> },
          { text: 'Cities Trash',         path: '/CitiesTrash',          icon: <DeleteOutlineIcon /> },
      ]},
  ]},
];

const salesMenuItems = [
  { text: 'My Dashboard', path: '/SalesDashboard',   icon: <GridViewRoundedIcon /> },
  { text: 'My Leads',     path: '/AllLeadsForSales', icon: <PeopleAltOutlinedIcon /> },
  { text: 'Add Lead',     path: '/addclient',        icon: <PersonAddAltOutlinedIcon /> },

          { text: 'PF Integration', path: '/property-finder-integration',     icon: <WebhookIcon /> },

];
const teamLeaderMenuItems = [
  { text: 'My Dashboard', path: '/TeamleaderDashboard',   icon: <GridViewRoundedIcon /> },
  { text: 'My Leads',     path: '/AllLeadsForTeamLeader', icon: <PeopleAltOutlinedIcon /> },
  { text: 'My Sales',     path: '/TeamLeaderMysales',     icon: <PersonPinOutlinedIcon /> },
  { text: 'Add Lead',     path: '/addclient',             icon: <PersonAddAltOutlinedIcon /> },
            { text: 'PF Integration', path: '/property-finder-integration',     icon: <WebhookIcon /> },

];
const managerMenuItems = [
  { text: 'My Dashboard',      path: '/ManagerDashboard',         icon: <GridViewRoundedIcon /> },
  { text: 'My Leads',          path: '/LeadsForManagers',         icon: <PeopleAltOutlinedIcon /> },
  { text: 'My Team Leaders',   path: '/MyTeamLeadersForManagers', icon: <SwitchAccountOutlinedIcon /> },
  { text: 'My Team Analytics', path: '/TeamAnalyticForManager',   icon: <StackedLineChartOutlinedIcon /> },
  { text: 'Add Lead',          path: '/addclient',                icon: <PersonAddAltOutlinedIcon /> },
            { text: 'PF Integration', path: '/property-finder-integration',     icon: <WebhookIcon /> },

];
const accountantMenuItems = [
  { text: 'My Done Deals',      path: '/LeadsForAccountant',                  icon: <Diversity3Icon /> },
  { text: 'Sales Report',       path: '/SalesMonyinMonthReportForAccountant', icon: <ShowChartIcon /> },
  { text: 'Developers Account', path: '/DeveloperAccounts',                   icon: <AccountBoxIcon /> },
  { text: 'Add Tasks',          path: '/AccountantTasks',                     icon: <AddTaskIcon /> },
  { text: 'Manage Tasks',       path: '/ManageAccountantTasks',               icon: <AssignmentIcon /> },
  { text: 'Inventory', icon: <Inventory2OutlinedIcon />, children: [
      { text: 'Projects',   path: '/Project',    icon: <AssistantPhotoIcon /> },
      { text: 'City',       path: '/AddCity',    icon: <WhereToVoteIcon /> },
      { text: 'Developers', path: '/Developers', icon: <LoupeIcon /> },
  ]},
];
const marketerMenuItems = [
  { text: 'Dashboard', path: '/dashboard', icon: <GridViewRoundedIcon /> },
  { text: 'Leads', path: '/ALLLeadsForMarketer', icon: <PersonSearchOutlinedIcon /> },
  { text: 'Inventory', icon: <Inventory2OutlinedIcon />, children: [
      { text: 'Projects',   path: '/Project',    icon: <AccountTreeOutlinedIcon /> },
      { text: 'City',       path: '/AddCity',    icon: <ApartmentOutlinedIcon /> },
      { text: 'Developers', path: '/Developers', icon: <HomeWorkOutlinedIcon /> },
  ]},
  { text: 'Stages',            icon: <HorizontalSplitOutlinedIcon />, path: '/Stages' },
  { text: 'Channel',           icon: <VideoSettingsOutlinedIcon />,   path: '/Channel' },
  { text: 'Regions & Areas', icon: <SouthAmericaIcon />, children: [
      { text: 'Region', path: '/Regionsandareas', icon: <LocationSearchingOutlinedIcon /> },
      { text: 'Areas',  path: '/Areas',           icon: <AddLocationOutlinedIcon /> },
  ]},
  { text: 'Communication Way', icon: <BubbleChartOutlinedIcon />,     path: '/Communicationway' },
  { text: 'Campaigns',         icon: <CampaignOutlinedIcon />,        path: '/Campaigns' },
  { text: 'Cancel Reason',     icon: <DoNotDisturbAltOutlinedIcon />, path: '/cancelreasons' },
  { text: 'Reports', icon: <BarChartOutlinedIcon />, children: [
      { text: 'Marketing Reports', path: '/MarketingReports',          icon: <BarChartOutlinedIcon /> },
      { text: 'Campaigns Reports', path: '/CampaignsReports',          icon: <BarChartOutlinedIcon /> },
      { text: 'Collect Reports',   path: '/ImportantMarketingReports', icon: <BarChartOutlinedIcon /> },
  ]},
  { text: 'Integration', icon: <WebhookIcon />, children: [
      { text: 'Webhook',          path: '/integration',         icon: <WebhookIcon /> },
      { text: 'Facebook',         path: '/Facebookintegration', icon: <FacebookIcon /> },
      { text: 'More Integration', path: '/MoreIntegration',     icon: <ExpandCircleDownOutlinedIcon /> },
                { text: 'PF Integration', path: '/property-finder-integration',     icon: <WebhookIcon /> },

  ]},
];

const menuMap = {
  Admin: adminMenuItems, Sales: salesMenuItems,
  'Team Leader': teamLeaderMenuItems, Manager: managerMenuItems,
  Accountant: accountantMenuItems,   Marketer: marketerMenuItems,
};

// ─── helpers ──────────────────────────────────────────────────────────────────
const hasActiveChild = (node, pathname) => {
  if (node.path) return pathname === node.path;
  return node.children?.some(c => hasActiveChild(c, pathname));
};

// ─── NavLeaf ──────────────────────────────────────────────────────────────────
const NavLeaf = ({ item, depth, expanded, onExpand }) => {
  const { pathname } = useLocation();
  const active = pathname === item.path;

  const inner = (
    <ListItem button component={Link} to={item.path}
      onClick={() => { if (!expanded) onExpand(); }}
      sx={{
        pl: expanded ? `${16 + depth * 14}px` : 0,
        pr: expanded ? '12px' : 0,
        py: '10px',
        mx: expanded ? '8px' : '6px',
        width: expanded ? 'calc(100% - 16px)' : 'calc(100% - 12px)',
        borderRadius: '8px', mb: '2px',
        position: 'relative',
        justifyContent: expanded ? 'flex-start' : 'center',
        bgcolor: active ? '#FFFFFF' : 'transparent',
        boxShadow: active ? '0 1px 6px rgba(0,0,0,0.08)' : 'none',
        transition: 'all 0.2s',
        '&:hover': { bgcolor: active ? '#FFFFFF' : C.hoverBg },
        '&::before': active && expanded ? {
          content: '""', position: 'absolute',
          left: 0, top: '18%', bottom: '18%',
          width: '3px', bgcolor: C.accent,
          borderRadius: '0 3px 3px 0',
        } : {},
      }}
    >
      <ListItemIcon sx={{
        minWidth: 0, mr: expanded ? '10px' : 0,
        color: active ? C.accent : C.textMuted,
        '& svg': { fontSize: '20px' },
        transition: 'color 0.15s',
        justifyContent: 'center',
      }}>
        {item.icon}
      </ListItemIcon>
      {expanded && (
        <ListItemText primary={item.text} primaryTypographyProps={{
          fontSize: depth === 0 ? '13.5px' : '13px',
          fontWeight: active ? 600 : 400,
          color: active ? C.accent : (depth > 0 ? C.textMuted : C.text),
          fontFamily: "'DM Sans', sans-serif",
        }} />
      )}
    </ListItem>
  );

  return expanded ? inner : <Tooltip title={item.text} placement="right" arrow>{inner}</Tooltip>;
};

// ─── NavGroup ─────────────────────────────────────────────────────────────────
const NavGroup = ({ item, depth, expanded, onExpand }) => {
  const { pathname } = useLocation();
  const childActive = hasActiveChild(item, pathname);
  const [open, setOpen] = useState(false);

  useEffect(() => { if (childActive && expanded) setOpen(true); }, [pathname, expanded]);
  useEffect(() => { if (!expanded) setOpen(false); }, [expanded]);

  const handleClick = () => {
    if (!expanded) { onExpand(); return; }
    setOpen(p => !p);
  };

  const inner = (
    <ListItem button onClick={handleClick}
      sx={{
        pl: expanded ? `${16 + depth * 14}px` : 0,
        pr: expanded ? '12px' : 0,
        py: '10px',
        mx: expanded ? '8px' : '6px',
        width: expanded ? 'calc(100% - 16px)' : 'calc(100% - 12px)',
        borderRadius: '8px', mb: '2px',
        justifyContent: expanded ? 'flex-start' : 'center',
        bgcolor: childActive && !open && expanded ? 'rgba(26,62,207,0.06)' : 'transparent',
        transition: 'all 0.2s',
        '&:hover': { bgcolor: C.hoverBg },
      }}
    >
      <ListItemIcon sx={{
        minWidth: 0, mr: expanded ? '10px' : 0,
        color: childActive ? C.accent : C.textMuted,
        '& svg': { fontSize: '20px' },
        transition: 'color 0.15s',
        justifyContent: 'center',
      }}>
        {item.icon}
      </ListItemIcon>
      {expanded && (
        <>
          <ListItemText primary={item.text} primaryTypographyProps={{
            fontSize: depth === 0 ? '13.5px' : '13px',
            fontWeight: childActive ? 600 : 400,
            color: childActive ? C.accent : (depth > 0 ? C.textMuted : C.text),
            fontFamily: "'DM Sans', sans-serif",
          }} />
          {open
            ? <ExpandLess sx={{ fontSize: '16px', color: C.textMuted }} />
            : <ExpandMore sx={{ fontSize: '16px', color: C.textMuted }} />}
        </>
      )}
    </ListItem>
  );

  return (
    <>
      {expanded ? inner : <Tooltip title={item.text} placement="right" arrow>{inner}</Tooltip>}
      {expanded && (
        <Collapse in={open} timeout={180} unmountOnExit>
          {depth === 0 ? (
            <Box sx={{ ml: '34px', borderLeft: `1.5px solid ${C.border}`, my: '2px', pl: '2px' }}>
              <List disablePadding>
                {item.children.map((child, i) =>
                  child.children
                    ? <NavGroup key={i} item={child} depth={depth + 1} expanded={expanded} onExpand={onExpand} />
                    : <NavLeaf  key={i} item={child} depth={depth + 1} expanded={expanded} onExpand={onExpand} />
                )}
              </List>
            </Box>
          ) : (
            <List disablePadding sx={{ pl: '6px' }}>
              {item.children.map((child, i) =>
                child.children
                  ? <NavGroup key={i} item={child} depth={depth + 1} expanded={expanded} onExpand={onExpand} />
                  : <NavLeaf  key={i} item={child} depth={depth + 1} expanded={expanded} onExpand={onExpand} />
              )}
            </List>
          )}
        </Collapse>
      )}
    </>
  );
};

// ─── FooterRow ────────────────────────────────────────────────────────────────
const FooterRow = ({ icon, label, onClick, danger, expanded }) => {
  const inner = (
    <ListItem button onClick={onClick}
      sx={{
        px: expanded ? '12px' : 0, py: '9px',
        mx: expanded ? '8px' : '6px',
        width: expanded ? 'calc(100% - 16px)' : 'calc(100% - 12px)',
        borderRadius: '8px', mb: '1px',
        justifyContent: expanded ? 'flex-start' : 'center',
        gap: expanded ? '10px' : 0,
        transition: 'all 0.2s',
        '&:hover': { bgcolor: danger ? 'rgba(239,68,68,0.06)' : C.hoverBg },
        '&:hover .fi': { color: danger ? '#EF4444' : C.text },
        '&:hover .fl': { color: danger ? '#EF4444' : C.text },
      }}
    >
      <ListItemIcon sx={{ minWidth: 0, justifyContent: 'center', '& svg': { fontSize: '19px' } }}>
        <Box component="span" className="fi"
          sx={{ color: C.textMuted, display: 'flex', transition: 'color 0.15s' }}>
          {icon}
        </Box>
      </ListItemIcon>
      {expanded && (
        <ListItemText className="fl" primary={label} primaryTypographyProps={{
          fontSize: '13.5px', fontWeight: 400, color: C.text,
          fontFamily: "'DM Sans', sans-serif",
          sx: { transition: 'color 0.15s' },
        }} />
      )}
    </ListItem>
  );
  return expanded ? inner : <Tooltip title={label} placement="right" arrow>{inner}</Tooltip>;
};

// ─── DataCenterNav — الـ menu المخصص لصفحات الـ Data Center ──────────────────
const DataCenterNav = ({ routes, expanded, onExpand, navigate }) => {
  const { pathname } = useLocation();

  const items = [
    {
      text: 'DC Dashboard',
      path: routes.dashboard,
      icon: <StorageOutlinedIcon />,
    },
    {
      text: 'DC Leads',
      path: routes.leads,
      icon: <PeopleAltOutlinedIcon />,
    },
  ];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>

      {/* ── Badge: Data Center mode ── */}
      {expanded && (
        <Box sx={{
          mx: '12px', mb: '8px', mt: '4px',
          px: '10px', py: '7px',
          borderRadius: '8px',
          bgcolor: 'rgba(217,119,6,0.08)',
          border: '1px solid rgba(217,119,6,0.2)',
          display: 'flex', alignItems: 'center', gap: '8px',
        }}>
          <StorageOutlinedIcon sx={{ fontSize: '14px', color: '#D97706', flexShrink: 0 }} />
          <Typography sx={{
            fontSize: '11px', fontWeight: 700, color: '#D97706',
            fontFamily: "'DM Sans', sans-serif",
            letterSpacing: '0.06em', textTransform: 'uppercase',
          }}>
            Data Center Mode
          </Typography>
        </Box>
      )}

      {/* ── Nav items ── */}
      <List disablePadding sx={{ flex: 1 }}>
        {items.map((item, i) => {
          const active = pathname === item.path;
          const inner = (
            <ListItem
              key={i}
              button
              component={Link}
              to={item.path}
              onClick={() => { if (!expanded) onExpand(); }}
              sx={{
                pl: expanded ? '16px' : 0,
                pr: expanded ? '12px' : 0,
                py: '10px',
                mx: expanded ? '8px' : '6px',
                width: expanded ? 'calc(100% - 16px)' : 'calc(100% - 12px)',
                borderRadius: '8px', mb: '2px',
                position: 'relative',
                justifyContent: expanded ? 'flex-start' : 'center',
                bgcolor: active ? '#FFFFFF' : 'transparent',
                boxShadow: active ? '0 1px 6px rgba(0,0,0,0.08)' : 'none',
                transition: 'all 0.2s',
                '&:hover': { bgcolor: active ? '#FFFFFF' : C.hoverBg },
                '&::before': active && expanded ? {
                  content: '""', position: 'absolute',
                  left: 0, top: '18%', bottom: '18%',
                  width: '3px', bgcolor: '#D97706',
                  borderRadius: '0 3px 3px 0',
                } : {},
              }}
            >
              <ListItemIcon sx={{
                minWidth: 0, mr: expanded ? '10px' : 0,
                color: active ? '#D97706 !important' : C.textMuted,
                '& svg': { fontSize: '20px' },
                transition: 'color 0.15s',
                justifyContent: 'center',
              }}>
                {item.icon}
              </ListItemIcon>
              {expanded && (
                <ListItemText primary={item.text} primaryTypographyProps={{
                  fontSize: '13.5px',
                  fontWeight: active ? 600 : 400,
                  color: active ? '#D97706' : C.text,
                  fontFamily: "'DM Sans', sans-serif",
                }} />
              )}
            </ListItem>
          );
          return expanded
            ? inner
            : <Tooltip key={i} title={item.text} placement="right" arrow>{inner}</Tooltip>;
        })}
      </List>

      {/* ── Divider ── */}
      <Box sx={{ mx: expanded ? '16px' : '10px', my: '8px', height: '1px', bgcolor: C.divider }} />

      {/* ── Return to Original Leads ── */}
      {(() => {
        const inner = (
          <ListItem
            button
            component={Link}
            to={routes.returnTo}
            sx={{
              pl: expanded ? '16px' : 0,
              pr: expanded ? '12px' : 0,
              py: '10px',
              mx: expanded ? '8px' : '6px',
              width: expanded ? 'calc(100% - 16px)' : 'calc(100% - 12px)',
              borderRadius: '8px', mb: '2px',
              justifyContent: expanded ? 'flex-start' : 'center',
              bgcolor: 'rgba(26,62,207,0.05)',
              border: '1px solid rgba(26,62,207,0.12)',
              transition: 'all 0.2s',
              '&:hover': {
                bgcolor: 'rgba(26,62,207,0.1)',
                borderColor: 'rgba(26,62,207,0.3)',
              },
            }}
          >
            <ListItemIcon sx={{
              minWidth: 0, mr: expanded ? '10px' : 0,
              color: '#1A3ECF !important',
              '& svg': { fontSize: '20px' },
              justifyContent: 'center',
            }}>
              <ArrowBackOutlinedIcon />
            </ListItemIcon>
            {expanded && (
              <ListItemText primary="Original Leads" primaryTypographyProps={{
                fontSize: '13.5px', fontWeight: 600,
                color: '#1A3ECF !important',
                fontFamily: "'DM Sans', sans-serif",
              }} />
            )}
          </ListItem>
        );
        return expanded
          ? inner
          : <Tooltip title="Return to Original Leads" placement="right" arrow>{inner}</Tooltip>;
      })()}
    </Box>
  );
};

// ─── Main ─────────────────────────────────────────────────────────────────────
export const Leftsidebare2 = ({ setmode, mode, openDrawer, isMobile, toggleDrawer, setOpenDrawer, onExpandedChange }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const [expanded,      setExpanded]      = useState(true);
  const [userlogin,     setUserlogin]     = useState(null);
  const [loadinglogout, setLoadinglogout] = useState(true);
  const [isLoggedOut,   setIsLoggedOut]   = useState(localStorage.getItem('isLoggedIn'));
  const savedDeviceId = localStorage.getItem('deviceId');

  const handleExpand = () => {
    setExpanded(true);
    localStorage.setItem('sidebarExpanded', 'true');
  };

  useEffect(() => {
    if (typeof onExpandedChange === 'function') onExpandedChange(expanded);
    window.dispatchEvent(new CustomEvent('sidebarResized', {
      detail: { width: expanded ? EXPANDED_WIDTH : COLLAPSED_WIDTH }
    }));
  }, [expanded]);

  useEffect(() => {
    const u = JSON.parse(localStorage.getItem('user'));
    if (u) setUserlogin(u);
  }, []);

  useEffect(() => {
    const path = location.pathname;
    const hide = path === '/' || path === '/Login';
    if (typeof setOpenDrawer === 'function') setOpenDrawer(!hide);
    const nb = document.getElementById('navbarr');
    if (nb) nb.style.display = hide ? 'none' : 'flex';
  }, [location.pathname, setOpenDrawer]);

  const logout = async () => {
    setLoadinglogout(true);
    await dispatch(Logoutsession_one_Device(userlogin?.data?._id, savedDeviceId));
    setLoadinglogout(false);
  };

  useEffect(() => {
    if (!loadinglogout) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.setItem('isLoggedIn', 'false');
      window.location.href = '#/';
    }
  }, [loadinglogout]);

  const role         = userlogin?.data?.role;
  const menuItems    = menuMap[role] || [];
  const isPrivileged = ['Sales','Team Leader','Manager','Admin','Marketer','Accountant'].includes(role);
  const drawerWidth  = expanded ? EXPANDED_WIDTH : COLLAPSED_WIDTH;

  // ── هل أنا في Data Center دلوقتي؟ ────────────────────────────────────────
  const isInDataCenter = ALL_DATA_CENTER_PATHS.includes(location.pathname);
  const dataCenterRoutes = DATA_CENTER_ROUTES[role];

  if (isLoggedOut !== 'true') return null;

  const content = (
    <Box sx={{
      display: 'flex', flexDirection: 'column',
      height: '100%', bgcolor: C.sidebarBg,
      width: drawerWidth,
      transition: 'width 0.25s cubic-bezier(0.4,0,0.2,1)',
      overflow: 'hidden',
    }}>

      {/* ── Brand + toggle ── */}
      <Box sx={{
        height: '64px',
        px: expanded ? 2.5 : 0,
        display: 'flex', alignItems: 'center',
        justifyContent: expanded ? 'space-between' : 'center',
        bgcolor: C.topBg,
        borderBottom: `1px solid ${C.border}`,
        flexShrink: 0,
      }}>
        {expanded && (
          <Box>
            <Typography sx={{
              fontFamily: "'DM Sans', sans-serif", fontWeight: 800, fontSize: '12.5px',
              color: C.accent, letterSpacing: '0.13em', textTransform: 'uppercase',
              lineHeight: 1.3, whiteSpace: 'nowrap',
            }}>
              Realatix CRM
            </Typography>
            <Typography sx={{
              fontFamily: "'DM Sans', sans-serif", fontWeight: 400, fontSize: '9px',
              color: C.textMuted, letterSpacing: '0.15em',
              textTransform: 'uppercase', whiteSpace: 'nowrap',
            }}>
              {isInDataCenter ? 'Data Center' : 'Elite Tier Access'}
            </Typography>
          </Box>
        )}

        <Tooltip title={expanded ? 'Collapse' : 'Expand'} placement="right">
          <Box
            onClick={() => setExpanded(p => {
              const next = !p;
              localStorage.setItem('sidebarExpanded', String(next));
              return next;
            })}
            sx={{
              width: 28, height: 28, borderRadius: '6px',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              cursor: 'pointer', flexShrink: 0,
              color: C.textMuted,
              border: `1px solid ${C.border}`,
              bgcolor: '#fff',
              transition: 'all 0.15s',
              '&:hover': { color: C.accent, borderColor: C.accent, bgcolor: 'rgba(26,62,207,0.04)' },
            }}
          >
            {expanded
              ? <ChevronLeftIcon  sx={{ fontSize: '17px' }} />
              : <ChevronRightIcon sx={{ fontSize: '17px' }} />}
          </Box>
        </Tooltip>
      </Box>

      {/* ── Nav ── */}
      <Box sx={{
        flex: 1, overflowY: 'auto', overflowX: 'hidden', py: '10px',
        scrollbarWidth: 'none', '&::-webkit-scrollbar': { display: 'none' },
      }}>
        {/* لو في Data Center → اعرض الـ menu المخصص، غير كده → الـ menu العادي */}
        {isInDataCenter && dataCenterRoutes ? (
          <DataCenterNav
            routes={dataCenterRoutes}
            expanded={expanded}
            onExpand={handleExpand}
            navigate={navigate}
          />
        ) : (
          <List disablePadding>
            {menuItems.map((item, i) =>
              item.children
                ? <NavGroup key={i} item={item} depth={0} expanded={expanded} onExpand={handleExpand} />
                : <NavLeaf  key={i} item={item} depth={0} expanded={expanded} onExpand={handleExpand} />
            )}
          </List>
        )}
      </Box>

      {/* ── CTA — بس لو مش في Data Center ── */}
      {!isInDataCenter && (
        <Box sx={{ px: expanded ? 1.5 : '6px', pb: 1, flexShrink: 0 }}>
          {expanded ? (
            <Box onClick={() => navigate('/addclient')} sx={{
              bgcolor: '#0D47A1', color: '#fff', borderRadius: '8px', py: '11px',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              gap: '7px', cursor: 'pointer',
              fontFamily: "'DM Sans', sans-serif", fontSize: '12px', fontWeight: 700,
              letterSpacing: '0.1em', textTransform: 'uppercase',
              boxShadow: '0 2px 10px rgba(26,62,207,0.22)',
              transition: 'background 0.15s, box-shadow 0.15s',
              '&:hover': { bgcolor: C.ctaHover },
              '&:active': { transform: 'scale(0.98)' },
            }}>
              <AddCircleOutlinedIcon sx={{ fontSize: '16px' }} />
              Create New Lead
            </Box>
          ) : (
            <Tooltip title="New Listing" placement="right">
              <Box onClick={() => navigate('/addclient')} sx={{
                bgcolor: C.ctaBg, color: '#0D47A1', borderRadius: '8px', py: '10px',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                cursor: 'pointer', boxShadow: '0 2px 10px rgba(26,62,207,0.22)',
                '&:hover': { bgcolor: C.ctaHover },
              }}>
                <AddCircleOutlinedIcon sx={{ fontSize: '20px' }} />
              </Box>
            </Tooltip>
          )}
        </Box>
      )}

      {/* ── Footer ── */}
      {isPrivileged && (
        <Box sx={{ borderTop: `1px solid ${C.divider}`, pt: '6px', pb: '10px', flexShrink: 0 }}>
          <FooterRow icon={<HelpOutlineIcon />}           label="Support"  onClick={() => navigate('/support')}   expanded={expanded} />
          <FooterRow icon={<AccountCircleOutlinedIcon />} label="Account"  onClick={() => navigate('/MyAccount')} expanded={expanded} />
          {/* <FooterRow icon={<LogoutIcon />}                label="Logout"   onClick={logout} danger expanded={expanded} /> */}
        </Box>
      )}
    </Box>
  );

  return (
    <Drawer
      variant={isMobile ? 'temporary' : 'persistent'}
      open={openDrawer}
      onClose={() => setOpenDrawer(false)}
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        transition: 'width 0.25s cubic-bezier(0.4,0,0.2,1)',
        zIndex: (t) => t.zIndex.appBar,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          top: 0, height: '100vh',
          border: 'none',
          borderRight: `1px solid ${C.border}`,
          overflowX: 'hidden',
          bgcolor: C.sidebarBg,
          transition: 'width 0.25s cubic-bezier(0.4,0,0.2,1)',
        },
      }}
    >
      {content}
    </Drawer>
  );
};
